import { Util } from '@/modules/util'
import { Request } from '@/classes/Request'

// POST /ajax/sso_login
export const ssoLogin = async (payload: Object): Promise<any> => {
  return new Promise((resolve, reject) => {
    const req = new Request()
    req
      .post(`/ajax/sso_login`, payload)
      .then(response => {
        resolve(Util.Obj.keysToCamel(response.data))
      })
      .catch(err => {
        if (err.response.status === 400) {
          reject('Failed to SSO - Missing family user id')
        }
        if (err.response.status === 401) {
          reject('Failed to SSO - Invalid family user id')
        }
        if (err.response.status === 429 || err.response.status === 500) {
          reject('Failed to SSO, please try again later')
        }
      })
  })
}
